import { createTestIds } from '../../utils';

export const getAIRewriteTestIds = createTestIds('ai-rewrite-popover', [
  'radio-clearer',
  'radio-shorter',
  'radio-professional',
  'radio-friendly',
  'instructions-input',
  'generate-button'
] as const);
